import { render, staticRenderFns } from "./SettingIntroBanner.vue?vue&type=template&id=2c808b40&"
import script from "./SettingIntroBanner.vue?vue&type=script&lang=js&"
export * from "./SettingIntroBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c808b40')) {
      api.createRecord('2c808b40', component.options)
    } else {
      api.reload('2c808b40', component.options)
    }
    module.hot.accept("./SettingIntroBanner.vue?vue&type=template&id=2c808b40&", function () {
      api.rerender('2c808b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/SettingIntroBanner.vue"
export default component.exports